import React from 'react';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { Box } from '@atlaskit/primitives';

const styles = cssMap({
  recaptchaNotice: {
    marginTop: token('space.100'),
  },
});

export const RecaptchaNoticeContainer = ({ children }: { children: React.ReactNode }) => (
  <Box xcss={styles.recaptchaNotice}>{children}</Box>
);
